export const types = {
  LOGIN_REQUEST:'LOGIN_REQUEST',
  LOGIN_SUCCESS:'LOGIN_SUCCESS',
  LOGIN_FAILURE:'LOGIN_FAILURE',
  LOGOUT: 'LOGOUT',
  SIDEBAR_TOGGLE: 'SIDEBAR_TOGGLE',
  SIDEBAR_UNFOLDABLE_TOGGLE: 'SIDEBAR_UNFOLDABLE_TOGGLE',
  SET_THEME: 'SET_THEME'
};
